import React from 'react';

import {
  Users,
} from 'lucide-react';

import Pagination from '../../../shared/components/Pagination';

import MemberFilterBar from '../components/MemberFilterBar';
import MemberMobileList from '../components/MemberMobileList';
import MemberTable from '../components/MemberTable';

import {
  useAdminMembers,
} from '../hooks/useAdminMembers';

const AdminMemberPage:
  React.FC = () => {
  const {
    stores,
    loading,

    searchTerm,
    setSearchTerm,

    statusFilter,
    setStatusFilter,

    storeFilter,
    setStoreFilter,

    filteredUsers,
    paginatedUsers,

    currentPage,
    setCurrentPage,

    itemsPerPage,

    hasActiveFilter,

    activateMember,
    deactivateMember,
  } = useAdminMembers();

  if (loading) {
    return (
      <div className="flex min-h-full items-center justify-center px-4 py-20">
        <div className="text-base text-gray-600 sm:text-lg">
          로딩 중...
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-full w-full flex-col px-4 pb-6 pt-4 sm:px-6 sm:pb-8 sm:pt-6 lg:px-8 lg:pt-8">
      <header className="mb-5 shrink-0 sm:mb-6">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <h1 className="text-2xl font-semibold text-black sm:text-3xl">
              회원 관리
            </h1>

            <p className="mt-1 text-sm text-gray-600 sm:text-base">
              회원 계정, 승인 및 상태를 관리합니다.
            </p>
          </div>

          <div className="flex items-center gap-2 rounded-full bg-white px-3 py-2 text-sm text-gray-600 shadow-sm ring-1 ring-gray-200">
            <Users
              size={18}
            />

            <span className="font-medium">
              {
                filteredUsers.length
              }
              명
            </span>
          </div>
        </div>
      </header>

      <MemberFilterBar
        stores={
          stores
        }
        searchTerm={
          searchTerm
        }
        statusFilter={
          statusFilter
        }
        storeFilter={
          storeFilter
        }
        onSearchChange={
          setSearchTerm
        }
        onStatusChange={
          setStatusFilter
        }
        onStoreChange={
          setStoreFilter
        }
      />

      <section className="flex-1 md:hidden">
        <MemberMobileList
          users={
            paginatedUsers
          }
          hasActiveFilter={
            hasActiveFilter
          }
          onActivate={
            activateMember
          }
          onDeactivate={
            deactivateMember
          }
        />
      </section>

      <MemberTable
        users={
          paginatedUsers
        }
        hasActiveFilter={
          hasActiveFilter
        }
        onActivate={
          activateMember
        }
        onDeactivate={
          deactivateMember
        }
      />

      {filteredUsers.length >
        0 && (
        <footer className="mt-5 shrink-0 overflow-x-auto pb-1 sm:mt-6">
          <div className="flex min-w-max justify-center">
            <Pagination
              currentPage={
                currentPage
              }
              totalItems={
                filteredUsers.length
              }
              itemsPerPage={
                itemsPerPage
              }
              onPageChange={
                setCurrentPage
              }
            />
          </div>
        </footer>
      )}
    </div>
  );
};

export default AdminMemberPage;